export default __webpack_public_path__ + "static/media/Bronze.60ec077c.svg";